import * as history from "./history";
// import * as deleteHistory from "./deleteHistory";
import * as exportHistory from "./export";

export default {
  ...history,
  ...exportHistory
  // ...deleteHistory
};
